module.exports = __webpack_public_path__ + "img/3-place-medal.37b9f98a.svg";